import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { agentAPI } from '@/features/agent/api/agentApi'

interface BankItem {
  code: string
  short_name: string
  name: string
  bin: string | null
  logo: string | null
}

interface BankState {
  banks: BankItem[]
  loading: boolean
  error: string | null
  fetched: boolean
}

const initialState: BankState = {
  banks: [],
  loading: false,
  error: null,
  fetched: false,
}

export const fetchSupportedBanks = createAsyncThunk(
  'bank/fetchSupportedBanks',
  async (_, { getState, rejectWithValue }) => {
    const state = getState() as { bank: BankState }
    if (state.bank.fetched) {
      return state.bank.banks
    }
    try {
      const data = await agentAPI.getSupportedBanks()
      return data
    } catch (err: any) {
      return rejectWithValue(err.message || 'Không thể tải danh sách ngân hàng')
    }
  }
)

const bankSlice = createSlice({
  name: 'bank',
  initialState,
  reducers: {
    clearBankCache(state) {
      state.banks = []
      state.fetched = false
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSupportedBanks.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchSupportedBanks.fulfilled, (state, action) => {
        state.banks = action.payload
        state.loading = false
        state.fetched = true
      })
      .addCase(fetchSupportedBanks.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
      })
  },
})

export const { clearBankCache } = bankSlice.actions
export default bankSlice.reducer
